var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "i5vz1qlaea-2",
    d: "M40,20A20,20,0,1,1,20,0,20.06,20.06,0,0,1,40,20",
    fill: "#e9eeef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4,18.6A4.84,4.84,0,0,0,25,15V13a5,5,0,0,0-10,0v2a4.75,4.75,0,0,0,1.5,3.6A10.07,10.07,0,0,0,10,28v1a.94.94,0,0,0,1,1H29a.94.94,0,0,0,1-1V28a10,10,0,0,0-6.6-9.4",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "tdip75kxoc-2",
    d: "M23.4,18.6A4.84,4.84,0,0,0,25,15V13a5,5,0,0,0-10,0v2a4.84,4.84,0,0,0,1.6,3.6A10,10,0,0,0,10,28v1a.94.94,0,0,0,1,1h6.6l1.7,1.7h0c.1.1.2.2.3.2a.6.6,0,0,0,.4.1h0a.37.37,0,0,0,.3-.1c.1,0,.2-.1.3-.2L22.3,30H29a.94.94,0,0,0,1-1V28A10,10,0,0,0,23.4,18.6Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "tdip75kxoc-2-2",
    "data-name": "tdip75kxoc-2",
    d: "M22.8,28l-1.6-7.9A8,8,0,0,1,28,28Zm-4-7.9L17.2,28H12A8,8,0,0,1,18.8,20.1ZM20,29.6l-.9-.9.9-4.6.9,4.6ZM17,13a3,3,0,0,1,6,0v2a3,3,0,0,1-6,0Zm6.4,5.6A4.84,4.84,0,0,0,25,15V13a5,5,0,0,0-10,0v2a4.84,4.84,0,0,0,1.6,3.6A10,10,0,0,0,10,28v1a.94.94,0,0,0,1,1h6.6l1.7,1.7h0c.1.1.2.2.3.2a.6.6,0,0,0,.4.1h0a.37.37,0,0,0,.3-.1c.1,0,.2-.1.3-.2L22.3,30H29a.94.94,0,0,0,1-1V28A10,10,0,0,0,23.4,18.6Z",
    fill: "#adb8be"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none",
    stroke: "#adb8be"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarTeacher);
export default __webpack_public_path__ + "static/media/avatar-teacher.d661d69d5e4c188cf0c603d5fbf5e213.svg";
export { ForwardRef as ReactComponent };